import { render } from "./AddNewSubResource.vue?vue&type=template&id=11591a02"
import script from "./AddNewSubResource.vue?vue&type=script&lang=js"
export * from "./AddNewSubResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__